var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 6.12793C11.307 6.25139 11.5614 6.45718 11.6981 6.71875L12.8924 9.00488C13.0004 9.21197 13.0207 9.42353 12.9755 9.62207V13.2383C12.9753 13.659 12.5298 14 11.9803 14H4.0194C3.4701 13.9998 3.02441 13.6589 3.02428 13.2383V9.62207C2.97909 9.42351 3.00028 9.21198 3.10826 9.00488L4.3026 6.71875C4.43926 6.45722 4.69395 6.25143 5.00768 6.12793L5.64342 6.76367C5.45854 6.77672 5.29631 6.86819 5.22643 7.00195L4.35631 8.66699H11.6434L10.7733 7.00195C10.7034 6.86823 10.5421 6.77669 10.3573 6.76367L10.993 6.12793Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3L8 7M6 5L8 7L10 5",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.91f8824e0a8c7af428def456d26bfa58.svg";
export { ForwardRef as ReactComponent };